"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ChangeDetectionStrategy, Component, HostBinding, Input, } from '@angular/core';
var LinkComponent = (function () {
    function LinkComponent() {
        this.rel = '';
        this.underline = 'hover';
        this.color = 'default';
        this.hoverColor = 'default';
        this.weight = 'inherit';
        this.noopener = false;
    }
    LinkComponent.prototype.isExternalLink = function (link, external) {
        // Check if the link is http(s) or protocol relative.
        return link.startsWith('http') || link.startsWith('//') || external;
    };
    LinkComponent.prototype.getLinkTarget = function (link, external) {
        return this.isExternalLink(link, external) ? '_blank' : undefined;
    };
    LinkComponent.prototype.ngOnChanges = function (changes) {
        var properties = Object.keys(changes);
        if (properties.includes('link') || properties.includes('external')) {
            var link = properties.includes('link')
                ? changes.link.currentValue
                : this.link;
            var external_1 = properties.includes('external')
                ? changes.external.currentValue
                : this.external;
            this.linkTarget = this.getLinkTarget(link, external_1);
        }
        if (properties.includes('link') ||
            properties.includes('rel') ||
            properties.includes('external')) {
            var link = properties.includes('link')
                ? changes.link.currentValue
                : this.link;
            var rel = properties.includes('rel')
                ? changes.rel.currentValue
                : this.rel;
            var external_2 = properties.includes('external')
                ? changes.external.currentValue
                : this.external;
            // Check if it's an external link and add rel="noopener" as
            // necessary because security exploits.
            // Ref: https://mathiasbynens.github.io/rel-noopener/
            this.noopener = this.isExternalLink(link, external_2);
            var relArray = rel.split(' ');
            if (this.noopener) {
                relArray.push('noopener');
            }
            this.allRel = relArray.join(' ').trim();
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], LinkComponent.prototype, "link", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], LinkComponent.prototype, "queryParams", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], LinkComponent.prototype, "rel", void 0);
    __decorate([
        HostBinding('attr.data-underline'),
        Input(),
        __metadata("design:type", String)
    ], LinkComponent.prototype, "underline", void 0);
    __decorate([
        HostBinding('attr.data-color'),
        Input(),
        __metadata("design:type", String)
    ], LinkComponent.prototype, "color", void 0);
    __decorate([
        HostBinding('attr.data-hover-color'),
        Input(),
        __metadata("design:type", String)
    ], LinkComponent.prototype, "hoverColor", void 0);
    __decorate([
        HostBinding('attr.data-weight'),
        Input(),
        __metadata("design:type", String)
    ], LinkComponent.prototype, "weight", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], LinkComponent.prototype, "external", void 0);
    LinkComponent = __decorate([
        Component({
            selector: 'fl-link',
            template: "\n    <a *ngIf=\"link\"\n      class=\"LinkElement\"\n      [routerLink]=\"link\"\n      [queryParams]=\"queryParams\"\n      [target]=\"linkTarget\"\n      [rel]=\"allRel\"\n    >\n      <ng-container [ngTemplateOutlet]=\"content\"></ng-container>\n    </a>\n\n    <button *ngIf=\"!link\"\n      class=\"LinkElement\"\n    >\n      <ng-container [ngTemplateOutlet]=\"content\"></ng-container>\n    </button>\n\n    <ng-template #content>\n      <ng-content></ng-content>\n    </ng-template>\n  ",
            styleUrls: ['./link.component.scss'],
            changeDetection: ChangeDetectionStrategy.OnPush,
        })
    ], LinkComponent);
    return LinkComponent;
}());
export { LinkComponent };



// WEBPACK FOOTER //
// link.component.js